import * as ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-xcode';
import { data } from 'jquery';

export default class FormUtils {
	static select2AjaxDelay = 200;

	/**
	 *
	 * @param {string} selector
	 * @param {boolean} visible
	 */
	static toggleFieldVisibility(selector, visible, customHiddenClass = 'hidden') {
		const field = typeof selector === 'string' ? $(selector) : selector;
		const container = field.closest('.field-container');
		container.toggleClass(customHiddenClass, !visible);
		if (field.prop('tagName') === 'DIV') {
			field.find('input, textarea, select').each(function () {
				FormUtils.toggleFieldEnabled($(this), visible);
			});
		} else {
			FormUtils.toggleFieldEnabled(selector, visible);
		}
	}

	static toggleFieldEnabled(selector, enabled) {
		const field = typeof selector === 'string' ? $(selector) : selector;
		const readonly = field.data('readonly');
		let disabled = !enabled;
		if (readonly) {
			disabled = true;
		}
		field.prop('disabled', disabled);
		const container = field.closest('.field-container');
		container.find('.additional-buttons button').prop('disabled', disabled);
		container.find('.additional-buttons a').css({
			'pointer-events': enabled ? 'auto' : 'none',
			cursor: enabled ? 'pointer' : 'not-allowed',
		});
	}

	static getFormData($form = '#pageForm') {
		if (typeof $form === 'string') {
			$form = $($form);
		}

		const unindexed_array = $form.serializeArray();
		const indexed_array = {};

		$.map(unindexed_array, function (n, i) {
			const $field = $form.find(`[name="${n['name']}"]`);
			if ($field.length && $field[0].nodeName === 'SELECT') {
				indexed_array[n['name']] = $field.val();
			} else {
				indexed_array[n['name']] = n['value'];
			}
		});

		return indexed_array;
	}

	static #templateSelectionCallback(multiple, selector) {
		return (data) => {
			if (multiple) {
				const length = $(selector).val().length;
				if (length > 1) {
					return length + ' selezionati';
				}
			}

			return data.text;
		};
	}

	static initializeAceEditor(selector, textarea, mode = 'json') {
		if (typeof textarea === 'string') {
			textarea = $(textarea);
		}

		// Mark source field so Form.formChangeHandler includes it when hidden (Ace replaces visible editing).
		textarea.attr('data-ace-editor-sync', '1');

		const editor = ace.edit(selector);
		editor.setTheme('ace/theme/xcode');
		editor.getSession().setMode(`ace/mode/${mode}`);
		editor.getSession().setOptions({
			tabSize: 4,
			useSoftTabs: true,
			useWorker: false,
		});
		editor.getSession().on('change', function () {
			textarea.val(editor.getSession().getValue());

			$('#save, #popupsave')
				.css({
					cursor: 'pointer',
					opacity: '1',
				})
				.prop('disabled', false)
				.removeClass('disabled');

			textarea.trigger('change');
		});

		editor.setShowPrintMargin(false);

		textarea.hide();

		textarea.val(editor.getSession().getValue());

		return editor;
	}

	/**
	 *
	 * @param {string} selector element selector
	 * @param {boolean} multiple is a multiple select?
	 * @param {string|number|'auto'} width width of the select2
	 * @param {string|null} placeholder placeholder of the select2 when no selection
	 * @param {boolean} truncateMultipleSelections truncate multiple selections and display the number of selected items
	 * @param {Object} customConfigs custom configurations for the select2
	 *
	 * @returns {jQuery} the select2 element
	 */
	static initializeSelect2(
		selector,
		multiple = false,
		width = 'auto',
		dropdownAutoWidth = true,
		placeholder = null,
		truncateMultipleSelections = false,
		customConfigs = {},
	) {
		const config = {
			width,
			multiple,
			closeOnSelect: customConfigs.closeOnSelect || !multiple,
			dropdownAutoWidth,
			placeholder: placeholder || 'Tutti',
			allowClear: customConfigs.allowClear || true,
			...customConfigs,
		};

		if (truncateMultipleSelections) {
			config.templateSelection = FormUtils.#templateSelectionCallback(multiple, selector);
		}

		if (config.ajax) {
			// config.ajax.cache = true;

			if (!config.ajax.data) {
				config.ajax.data = function (params) {
					return {
						q: params.term,
						page: params.page || 1,
						selected: $(selector).val(),
					};
				};
			}

			if (!config.ajax.processResults) {
				config.ajax.processResults = function (data) {
					return {
						results: $.map(data.results || data, function (obj) {
							const thumbUrl = obj.cover && !obj.cover.nocover ? obj.cover.thumb || obj.cover.original : obj.cover ? null : false;

							let text = obj.path || obj.name || obj.title || obj.text || obj;
							if (obj.published_at && obj.published_at.human) {
								if (!text.startsWith(obj.published_at.human)) {
									text = obj.published_at.human + ' - ' + text;
								}
							}

							const categorization = obj.sections || obj.folders || obj.categories || obj.types || obj.tags;
							if (categorization && categorization.length > 0) {
								text += ' [' + categorization.map((item) => item.name || item.title || item).join(', ') + ']';
							}

							return {
								id: obj.id || obj,
								url: obj.URL || obj.href || null,
								text: FormUtils.escapeHTML(text),
								thumb: thumbUrl,
								html: FormUtils.drawSelect2OptionWithThumbs(text, thumbUrl, obj.id || null),
							};
						}),
						pagination: data.pagination || null,
					};
				};
			}

			if (!config.ajax.dataType) {
				config.ajax.dataType = 'json';
			}

			config.ajax.delay = FormUtils.select2AjaxDelay;
		}

		if (!config.escapeMarkup) {
			config.escapeMarkup = (markup) => markup;
		}

		if (!config.templateResult) {
			config.templateResult = (data) => {
				if (data.loading) {
					return data.text;
				}
				return data.html || data.text;
			};
		}

		if (!config.templateSelection) {
			config.templateSelection = (data) => data.text;
		}

		const $selector = $(selector).select2(config);

		// ------------------------------------------------------

		// Set flag on mousedown (before Select2 handles click) so select2:opening can be prevented
		const $container = $selector.data('select2')?.$container;
		if ($container?.length) {
			$container.on('mousedown', '.select2-selection__choice__remove', function () {
				$selector.data('preventNextOpen', true);
			});
		}

		$selector
			.on('select2:opening', function (evt) {
				if ($(this).data('preventNextOpen')) {
					$(this).removeData('preventNextOpen');
					evt.preventDefault();
				}
			})
			.on('select2:select', function (evt) {
				const $this = $(this);
				$this.parent().find('.select2-search__field').val('');

				FormUtils.handleSelect2Change(evt, $this);
			})
			.on('select2:unselect', function (evt) {
				if (evt.params.originalEvent) {
					const $this = $(this);

					const values = $this.val();
					if (Array.isArray(values)) {
						$this.val(values.filter((item) => item !== evt.params.data.id.toString())).trigger('change');
					}

					const choiceId = evt.params.originalEvent.currentTarget.getAttribute('data-select2-id');
					$(`#select2-${evt.currentTarget.id}-results .select2-results__option[data-select2-id="${choiceId}"]`)
						.removeClass('select2-results__option--selected')
						.attr('aria-selected', 'false');

					// 	// Non rimuovere le opzioni per i select multipli con AJAX
					// 	// perché Select2 potrebbe cercare di ripristinarle durante le richieste AJAX
					// 	// causando conflitti di selezione/deselezione
					// 	const $select = $(evt.currentTarget);
					// 	if (!$select.prop('multiple')) {
					// 		$('#' + evt.currentTarget.id + " option[value='" + evt.params.data.id + "']").remove();
				}

				FormUtils.handleSelect2Change(evt, $(this));
			});

		setTimeout(() => {
			FormUtils.handleSelect2Change(null, $selector);
		}, 300);

		// ------------------------------------------------------

		return $selector;
	}

	static handleSelect2Change(evt, element) {
		if (element.closest('form').is('#filtersForm')) {
			const label = element.siblings('h6');
			const container = label.siblings('.select2-container').find('.select2-selection');
			let currentValue = element.select2('val');
			if (evt?.params._type === 'unselect') {
				const id = evt.params.data.id.toString();
				currentValue = Array.isArray(currentValue) ? currentValue.filter((item) => item !== id) : null;
			}
			if (
				currentValue === null ||
				currentValue === '' ||
				currentValue === 'all' ||
				currentValue === '0' ||
				(Array.isArray(currentValue) && currentValue.length === 0)
			) {
				container.removeClass('border border-primary');
			} else if (label.find('i.fa-circle').length === 0) {
				container.addClass('border border-primary');
			}
		}
	}

	static escapeHTML(str) {
		var p = document.createElement('p');
		p.appendChild(document.createTextNode(str));
		return p.innerHTML;
	}

	static drawSelect2OptionWithThumbs(text, thumbUrl = null, id = null) {
		if (thumbUrl === false) {
			return '';
		}

		return (
			(thumbUrl
				? `<img src="${thumbUrl}" class="item-select-thumb" alt="" onerror="this.style.display='none'" />`
				: `<span class="item-select-thumb bg-grey-200 d-inline-flex justify-content-center align-items-center grey-300">
					<i class="icon fa-solid fa-image fa-fw"></i>
				</span>`) + `<span class="item-select-text" data-option-id="${id}">${text}</span>`
		);
	}

	static openFormFieldConfigurator(fieldConfigs) {
		if (fieldConfigs.type === 'select') {
			fieldConfigs.attrs = Object.assign({ multiple: false, 'data-close-on-select': true }, fieldConfigs.attrs);
		} else if (fieldConfigs.type === 'number') {
			fieldConfigs.attrs = Object.assign({ min: 1, step: 1 }, fieldConfigs.attrs);
		} else if (fieldConfigs.type === 'text') {
			fieldConfigs.attrs = Object.assign({ 'data-seo-max': null, 'data-seo-min': null }, fieldConfigs.attrs);
		}

		let saveButton = null;

		$.magnificPopup.open(
			{
				items: {
					src: $('#popup'),
				},
				type: 'inline',
				closeOnBgClick: false,
				callbacks: {
					close: function () {
						saveButton.off('click');
						saveButton = null;
						const container = $('#popup-content');
						container.empty();
					},
					open: function () {
						const container = $('#popup-content');
						container.empty();

						const form = FormUtils.#getFormFieldHtml(fieldConfigs);
						container.html(form);

						let fleditor = ace.edit('config_attributes');
						let textarea = $('#config_attributes').siblings('textarea').first();

						fleditor.setTheme('ace/theme/github');
						fleditor.getSession().setMode('ace/mode/json');
						fleditor.getSession().setOptions({
							// theme: 'ace/theme/github',
							// mode: 'ace/mode/json',
							tabSize: 4,
							useSoftTabs: true,
						});
						fleditor.getSession().on('change', function () {
							textarea.val(fleditor.getSession().getValue());
						});
						const stringified = Array.isArray(fieldConfigs.attrs) ? '{}' : JSON.stringify(fieldConfigs.attrs, null, '\t');
						fleditor.setValue(stringified);
						textarea.val(stringified);

						saveButton = $('#editor-configs-form-submit');
						saveButton.off('click').on('click', function () {
							let attrs = {};
							try {
								attrs = JSON.parse($('#config_attributes').siblings('textarea').first().val() || '{}');
							} catch (e) {
								toastr.error('Formato JSON degli attributi non valido');
								return;
							}

							var json = {
								id: parseInt($('#config_id').val()),
								group: $('#config_group').val() || null,
								identifier: $('#config_identifier').val(),
								type: $('#config_type').val(),
								label: $('#config_label').val(),
								enabled: $('#config_enabled').val() === 'true',
								required: $('#config_required').val() === 'true',
								crud_route: $('#config_crud_route').val() || null,
								css_classes: $('#config_css_classes').val() || null,
								placeholder: $('#config_placeholder').val() || null,
								info: $('#config_info').val() || null,
								order: parseInt($('#config_order').val() || '0'),
								attrs: attrs,
							};

							const fieldIdx = FormConfigs.findIndex((field) => field.id === json.id);
							if (fieldIdx === -1) {
								toastr.error('Configurazione campo non trovata');
								return;
							}

							$.ajax({
								type: 'POST',
								url: window.appconfig.routes.form.edit + '?editing=true',
								data: JSON.stringify(json),
								success: function (data) {
									location.reload();
								},
								error: function (jqXHR) {
									let errorMessage = 'Si è verificato un errore inatteso, contattare il dipartimento IT';
									try {
										const response = JSON.parse(jqXHR.responseText);
										errorMessage = response.message || errorMessage;
									} catch (e) {
										console.error('Errore nel parsing della risposta:', jqXHR.responseText);
									}
									toastr.error(errorMessage);
								},
								contentType: 'application/json',
								dataType: 'json',
							});
						});
					},
				},
				midClick: true,
			},
			0,
		);
	}

	static #getFormFieldHtml(fieldConfigs) {
		return `
			<h3 class="text-center">Configurazione campo form</h3>
			<form id="editor-configs-form" class="p-4">
				<input required readonly disabled type="hidden" name="config_id" id="config_id" value="${fieldConfigs.id}" />
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_page">Pagina</label>
					</h4>
					<div class="col-sm-9">
						<input required readonly disabled name="config_page" id="config_page" class="form-control" value="${fieldConfigs.page}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_group">Gruppo</label>
					</h4>
					<div class="col-sm-9">
						<input name="config_group" id="config_group" class="form-control" value="${fieldConfigs.group ?? ''}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_identifier">Campo</label>
					</h4>
					<div class="col-sm-9">
						<input required readonly disabled name="config_identifier" id="config_identifier" class="form-control" value="${fieldConfigs.identifier}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_type">Tipo</label>
					</h4>
					<div class="col-sm-9">
						<select required id="config_type" name="config_type" class="form-control">
							<option value="text" ${fieldConfigs.type === 'text' ? 'selected' : ''}>Text</option>
							<option value="select" ${fieldConfigs.type === 'select' ? 'selected' : ''}>Select</option>
							<option value="boolean" ${fieldConfigs.type === 'boolean' ? 'selected' : ''}>Boolean</option>
							<option value="switch" ${fieldConfigs.type === 'switch' ? 'selected' : ''}>Switch</option>
							<option value="checkbox" ${fieldConfigs.type === 'checkbox' ? 'selected' : ''}>Checkbox</option>
							<option value="password" ${fieldConfigs.type === 'password' ? 'selected' : ''}>Password</option>
							<option value="textarea" ${fieldConfigs.type === 'textarea' ? 'selected' : ''}>Textarea</option>
							<option value="date" ${fieldConfigs.type === 'date' ? 'selected' : ''}>Date</option>
							<option value="datetime" ${fieldConfigs.type === 'datetime' ? 'selected' : ''}>Datetime</option>
							<option value="editor" ${fieldConfigs.type === 'editor' ? 'selected' : ''}>Editor</option>
							<option value="url" ${fieldConfigs.type === 'url' ? 'selected' : ''}>Url</option>
							<option value="cover_advanced" ${fieldConfigs.type === 'cover_advanced' ? 'selected' : ''}>Cover Advanced</option>
						</select>
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_label">Etichetta</label>
					</h4>
					<div class="col-sm-9">
						<input required name="config_label" id="config_label" class="form-control" value="${fieldConfigs.label}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_enabled">Abilitato</label>
					</h4>
					<div class="col-sm-9">
						<select id="config_enabled" name="config_enabled" class="form-control">
							<option value="true" ${fieldConfigs.enabled ? 'selected' : ''}>S&igrave;</option>
							<option value="false" ${!fieldConfigs.enabled ? 'selected' : ''}>No</option>
						</select>
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_required">Obbligatorio</label>
					</h4>
					<div class="col-sm-9">
						<select id="config_required" name="config_required" class="form-control">
							<option value="true" ${fieldConfigs.required ? 'selected' : ''}>S&igrave;</option>
							<option value="false" ${!fieldConfigs.required ? 'selected' : ''}>No</option>
						</select>
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_crud_route">Abilita pulsanti Crud</label>
					</h4>
					<div class="col-sm-9">
						<input name="config_crud_route" placeholder="Inserire nome endpoint" ${
							fieldConfigs.type !== 'select' ? 'readonly disabled' : ''
						} id="config_crud_route" class="form-control" value="${fieldConfigs.crud_route ?? ''}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_css_classes">Classi css</label>
					</h4>
					<div class="col-sm-9">
						<input name="config_css_classes" id="config_css_classes" class="form-control" value="${fieldConfigs.css_classes ?? ''}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_placeholder">Placeholder</label>
					</h4>
					<div class="col-sm-9">
						<input name="config_placeholder" id="config_placeholder" class="form-control" value="${fieldConfigs.placeholder ?? ''}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_info">Tooltip</label>
					</h4>
					<div class="col-sm-9">
						<input name="config_info" id="config_info" class="form-control" value="${fieldConfigs.info ?? ''}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_order">Ordinamento</label>
					</h4>
					<div class="col-sm-9">
						<input required type="number" step="1" name="config_order" id="config_order" class="form-control" value="${fieldConfigs.order}" />
					</div>
				</div>
				<div class="form-group row">
					<h4 class="example-title col-sm-3 mb-0">
						<label for="config_attributes">Attributi html</label>
					</h4>
					<div class="col-sm-9">
						<textarea class="ace_text-input" autocorrect="off" autocapitalize="none" spellcheck="false" wrap="off"></textarea>
						<div id="config_attributes" style="width:100%;height: 100%;min-height:200px"></div>
					</div>
				</div>
				<button type="button" id="editor-configs-form-submit" class="btn btn-primary w-full">Salva</button>
			</form>
		`;
	}
}
